<template>
    <div class="automation-block-editor find-contacts">
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t("automation.findContacts") }}</div>
            <AutomationContactSelector v-model="clone.filterGroups" />
        </div>
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">Offset</div>
            <TiptapEditor placeholder="Offset" :show-attributes="true" v-model="clone.offset" automation-mode />
            <small class="description">
                {{ $t("automation.offsetDesc") }}
            </small>
        </div>
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">Limit:</div>
            <TiptapEditor placeholder="Limit" :show-attributes="true" v-model="clone.limit" automation-mode />
            <small class="description">
                {{$t("automation.limitDesc")}}
            </small>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";
import CustomPicker from "../../../../../../../components/pickers/CustomPicker.vue";
import AutomationContactSelector from "../../toolbar/AutomationContactSelector.vue";

const log = log2("FindContacts");
export default {
    name: "FindContacts",
    components: { AutomationContactSelector, CustomPicker, SupsisButton, TiptapEditor },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            filter: {
                groups: [],
                operator: "or",
            },
            offset: "0",
            limit: "10",
        };
        return {
            clone,
        };
    },
    methods: {
        changeMode(mode) {
            this.clone.mode = mode;
        },
    },
    mounted() {
        console.log("FindContacts mounted");
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.automation-block-editor.find-contacts {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;

    section {
        width: 100%;
        display: flex;
        gap: 10px;
        flex-direction: column;
    }

    .editor-row {
        width: 100%;

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
        }

        &.customize-editor-minimize {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }

        small.description {
            font-size: 10px;
            color: var(--color-text-weak-default);
        }
    }

    .btnGroup {
        display: flex;
        border: 1px solid var(--color-border-default);
        border-radius: 6px;
        background: var(--color-bg-neutral-default);
        margin: 2px 10px;
        padding: 2px;

        .btnGrupItem {
            &.selected {
                background: var(--color-bg-oncomponent-default);
                box-shadow: var(--shadow-interaction-200);
            }
        }

        .supsis-button {
            border: none !important;
            font-size: 13px;
            height: 25px;
        }
    }
}
</style>
